import { createAPI } from '@common'

export default {
  // 弃用
  abandon: config => createAPI('customEncryptApiName-1/0w20dmvft0bcboepo', 'post', config)
}
